import { createSlice } from "@reduxjs/toolkit";
import {
  ApplicantDetailsROWResponse,
  ApplicationDetailsROWState
} from "../types";
import { fetchApplicationROWDetails } from "./services/thunk/DetailsThunk";

const initialState: ApplicationDetailsROWState = {
  applicationDetailsROW: null,
  loading: false,
  error: null
};

const DetailsSlice = createSlice({
  name: "details",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchApplicationROWDetails.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationROWDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.applicationDetailsROW = action.payload;
      })
      .addCase(fetchApplicationROWDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  }
});

export default DetailsSlice.reducer;
